module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/The-Story-of-God.4eda972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/The-Story-of-God.jpg
// module id = uahr
// module chunks = 0